import React from 'react'

import { FullScreenContainer, Loading } from '@jiaminghi/data-view-react'

import TopHeader from '../../common/TopHeader'

import './index.less'
import Error from '../../common/Error'
import Weather from '../../xyfy/weather'
import Time from '../../xyfy/time'
import Scope from '../../xyfy/scope'
import Reagent from '../../xyfy/reagent'
import Over from './zcTable'
import Batch from './zcTable_batch'
import Pie from './zcPie'
import Line from './zcScanLine'
import useWindowDimensions from '../../hook/window'

export default props => {
  const { height, width } = useWindowDimensions()
  return (
    <div className={'ptzx-page-container ptzx-zc-page-container'}>
      <div className={'no-10-top-bar'}>
        <div className={'weather-container'}>
          <Weather weather={'多云'} temp={'15-25°C'} />
        </div>
        <div className={'font-pm main-text'}>
          <span>体外诊断试剂SPD管理系统</span>
        </div>
        <div className={'time-container'}>
          <Time />
        </div>
      </div>
      <Scope
        type={'ks'}
        depList={[
          {
            name: '发热门诊',
            displayName: '发热门诊',
            image: '发热组',
          },
          {
            name: '分子室',
            displayName: '分子室',
            image: '分子细胞组',
          },
          {
            name: '急诊室',
            displayName: '急诊室',
            image: '急诊组',
          },
          {
            name: '门诊',
            displayName: '门诊',
            image: '门诊组',
          },
          {
            name: '免疫室',
            displayName: '免疫室',
            image: '免疫室',
          },
          {
            name: '生化室',
            displayName: '生化室',
            image: '生化室',
          },
          {
            name: '微生物',
            displayName: '微生物',
            image: '微生物',
          },
        ]}
      />
      <div
        className={'tables-container'}
        style={{
          marginBottom: '0.02vh',
        }}
      >
        <Over />
        <Batch />
      </div>
      <div
        className={'tables-container'}
        style={{
          marginTop: height * 0.03,
          marginBottom: height * 0.02,
        }}
      >
        <Pie />
        <Line />
      </div>
    </div>
  )
}
